module.exports = __webpack_public_path__ + "static/media/notstarted.7e423581.svg";